
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { LoadingSpinner } from "@/components/LoadingSpinner";
import { CookieConsent } from "@/components/CookieConsent";
import Index from "./pages/Index";
import Login from "./pages/Login";
import QueueDetail from "./pages/QueueDetail";
import Landing from "./pages/Landing";
import { AllQRCodesView } from "./components/queue-detail/AllQRCodesView";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      retryDelay: 1000,
    },
  },
});

const AppRoutes = () => {
  const { session, loading } = useAuth(queryClient);
  const location = useLocation();

  if (loading) {
    return <LoadingSpinner />;
  }

  const isAuthRoute = location.pathname === "/login";
  const isPublicRoute = location.pathname === "/";

  if (!session && !isAuthRoute && !isPublicRoute) {
    return <Navigate to="/login" replace />;
  }

  if (session && isAuthRoute) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route
        path="/dashboard"
        element={session ? <Index /> : <Navigate to="/login" replace />}
      />
      <Route
        path="/login"
        element={!session ? <Login /> : <Navigate to="/dashboard" replace />}
      />
      <Route
        path="/queue/:id"
        element={session ? <QueueDetail /> : <Navigate to="/login" replace />}
      />
      <Route
        path="/all-qr-codes"
        element={session ? <AllQRCodesView /> : <Navigate to="/login" replace />}
      />
    </Routes>
  );
};

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <AppRoutes />
          <CookieConsent />
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  );
};

export default App;
